/*
 * Frequently Bought With.
 *
 * When the product has Related Products set (the Search & Discovery metafield
 * shopify--discovery--product_recommendation.related_products), the strip is
 * already rendered into the page by snippets/product-frequently-bought.liquid
 * and this script only binds the Add buttons.
 *
 * Otherwise it loads sections/frequently-bought.liquid through the Section
 * Rendering API. Complementary products are requested first; if the product has
 * none, it falls back to Shopify's own related-product recommendations.
 *
 * Add to Cart reuses the theme's own flow from product-form.js: post to
 * routes.cart_add_url with the cart drawer's sections, then hand the response to
 * cartDrawer.renderContents() so the drawer refreshes and opens.
 */
if (!customElements.get('frequently-bought')) {
  class FrequentlyBought extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('[data-fbw-container]');
      if (!this.container || this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      // Rendered server-side from the product's Related Products metafield.
      // Nothing to fetch - the buttons just need wiring up.
      if (this.dataset.source === 'metafield') {
        this.hidden = false;
        this.bindButtons();
        return;
      }

      this.load('complementary');
    }

    buildUrl(intent) {
      return (
        this.dataset.url +
        '?section_id=' + this.dataset.sectionId +
        '&product_id=' + this.dataset.productId +
        '&limit=' + (this.dataset.limit || '5') +
        '&intent=' + intent
      );
    }

    load(intent) {
      fetch(this.buildUrl(intent))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const items = doc.querySelector('[data-fbw-items]');
          const count = items ? parseInt(items.dataset.fbwCount || '0', 10) : 0;

          if (count > 0 && items) {
            this.container.innerHTML = items.innerHTML;
            this.hidden = false;
            this.bindButtons();
            return;
          }

          // No complementary products set for this product, so let Shopify choose.
          if (intent === 'complementary') {
            this.load('related');
            return;
          }

          this.hidden = true;
        }.bind(this))
        .catch(function (e) {
          console.error('[frequently-bought]', e);
          this.hidden = true;
        }.bind(this));
    }

    bindButtons() {
      this.querySelectorAll('[data-fbw-add]').forEach(function (button) {
        button.addEventListener('click', this.addToCart.bind(this, button));
      }.bind(this));
    }

    addToCart(button) {
      const variantId = button.dataset.variantId;
      const cartDrawer = document.querySelector('cart-drawer');
      if (!variantId || button.classList.contains('disabled')) return;

      button.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cartDrawer && cartDrawer.getSectionsToRender) {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function (s) { return s.section; })
        );
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            console.error('[frequently-bought]', response.message);
            return;
          }
          if (cartDrawer && cartDrawer.renderContents) cartDrawer.renderContents(response);
        })
        .catch(function (e) { console.error('[frequently-bought]', e); })
        .finally(function () { button.classList.remove('disabled'); });
    }
  }

  customElements.define('frequently-bought', FrequentlyBought);
}
